import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { batchActions } from "@obg/ngrx-utils";
import { CustomerManagementAction } from "@obg/ngx.core";
import { PlatformService } from "@obg/ngx.global.evo";
import { RouteAction, RouteSelector } from "@obg/ngx.router";
import { filter, map, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { NEWSLETTER_UNSUBSCRIBE_TOKEN_NAME } from "./newsletter-unsubscribe.const";

@Injectable()
export class NewsletterUnsubscribeEffect {
	unsubscribeFromNewsletter$ = this.platformService.forClient(() =>
		createEffect(() =>
			this.actions$.pipe(
				ofType(RouteAction.resolveEnd),
				withLatestFrom(this.store.select(RouteSelector.getCurrent)),
				filter(
					([, route]) => route && route.queryParams && route.queryParams[NEWSLETTER_UNSUBSCRIBE_TOKEN_NAME]
				),
				map(([, route]) =>
					batchActions(
						this.customerManagementAction.unsubscribeFromNewsletter(
							route!.queryParams![NEWSLETTER_UNSUBSCRIBE_TOKEN_NAME]
						),
						RouteAction.updateQueryParams({ [NEWSLETTER_UNSUBSCRIBE_TOKEN_NAME]: null })
					)
				)
			)
		)
	);

	constructor(
		private customerManagementAction: CustomerManagementAction,
		private actions$: Actions,
		private store: Store<CommonState>,
		private platformService: PlatformService
	) {}
}
